import APIService from './APIService';

export default {
  getMunicipiosNaAreaConcessao(mesBdgd, versaoBdgd) {
    return APIService.apiCall().get(`/municipios/get-na-area-concessao/${mesBdgd}/${versaoBdgd}`);
  }
};
